import React, { useState } from "react";
import StudentNavbar from "../studentnavbar/StudentNavbar";
import StudentSidebar from "../studentsidebar/StudentSidebar";
import '../../../assets/css/student/StudentLayout.css'; 


const StudentLayout= ({ children, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="student-layout">
      {/* Sidebar */}
      <StudentSidebar
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      {/* Main Content */}
      <div
        className={`student-content-wrapper ${
          !sidebarOpen ? "full-width" : ""
        }`}
      >
        {/* Navbar */}
        <StudentNavbar
          sidebarOpen={sidebarOpen}
          onLogout={onLogout}
          toggleSidebar={toggleSidebar}
        />

        {/* Page Content */}
        <main className="student-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default StudentLayout;
